export default "__VITE_ASSET__B54iIre3__"